import ToggleSwitch from "../../../../../common/ToggleSwitch";
import React from "react";

/* Switch wrapper for saving or updating contact info */
export default function ToggleSwitchSection({ isShortFormSelected,
                                              isUserContactInfoIncluded,
                                              setIsUserContactInfoIncluded,
                                              setContactInfo,
                                              contactInfo }) {
    return (
        <div className="toggle-switch__section" style={isShortFormSelected ? {display: 'none'} : {}}>
            <ToggleSwitch
                isChecked={isUserContactInfoIncluded}
                onChange={value => {
                    setIsUserContactInfoIncluded(value);
                    setContactInfo({ ...contactInfo, isUserContactInfoIncluded: value });
                }}
            />
            <div className="text_primary">Save/Update Contact information in settings</div>
        </div>
    )
}